// Simple ICE server config; use public STUN for MVP.
export const RTC_CONFIG = {
  iceServers: [
    { urls: "stun:stun.l.google.com:19302" },
    { urls: "stun:stun1.l.google.com:19302" },
  ],
};

/**
 * Wait for ICE gathering to finish (non-trickle mode simplifies signaling).
 * Returns after `iceGatheringState === 'complete'` or 5s timeout.
 */
export function waitIceComplete(pc, timeoutMs = 5000) {
  return new Promise((resolve) => {
    if (pc.iceGatheringState === "complete") return resolve();
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      pc.removeEventListener("icegatheringstatechange", handler);
      resolve();
    };
    const handler = () => {
      if (pc.iceGatheringState === "complete") finish();
    };
    pc.addEventListener("icegatheringstatechange", handler);
    setTimeout(finish, timeoutMs);
  });
}
